import { cn } from "@/lib/utils";
import { formatPolicyStatusLabel } from "@/components/insured/policies/policy-status";

interface StatusPillProps {
  status: string | null | undefined;
  "data-testid"?: string;
}

const STATUS_COLORS: Record<string, string> = {
  active: "bg-emerald-500/10 text-emerald-600",
  renewing: "bg-emerald-500/10 text-emerald-600",
  reinstated: "bg-emerald-500/10 text-emerald-600",
  "pending cancel": "bg-amber-500/10 text-amber-600",
  "non-renewal": "bg-amber-500/10 text-amber-600",
  expired: "bg-muted text-muted-foreground",
  cancelled: "bg-muted text-muted-foreground",
  renewed: "bg-blue-500/10 text-blue-600",
  replaced: "bg-blue-500/10 text-blue-600",
  // CSR-1042 — Progressive "Renewal Offer". Same violet hue family as the
  // table badge in `policy-status.ts`; signals a transitional/not-yet-bound
  // state distinct from "renewed" (blue) and "replaced" (blue).
  "renewal offer": "bg-violet-500/10 text-violet-600",
  // CSR-1725/CSR-1699 — "Flat Cancel" is a cancellation-family status; same
  // muted treatment as "cancelled".
  "flat cancel": "bg-muted text-muted-foreground",
};

const DEFAULT_COLORS = "bg-muted text-muted-foreground";

export function StatusPill({ status, ...rest }: StatusPillProps) {
  const key = status?.toLowerCase() ?? "";
  const colors = STATUS_COLORS[key] ?? DEFAULT_COLORS;
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold",
        colors,
      )}
      data-testid={rest["data-testid"]}
    >
      {status ? formatPolicyStatusLabel(status) : ""}
    </span>
  );
}
